<template>
  <div>
    <v-form ref="form" v-model="valid" class="form-right-view-lable" @submit.prevent>
      <v-row class="flex-column">
        <v-col>
          <h2 class="primary-text">Forgot Password</h2>
        </v-col>
        <v-col>
          <v-text-field
            v-model="input.email"
            :rules="emailRules"
            label="Email Address"
            type="text"
            required
            @keyup.enter="submit"
          />
          <font color="red" class="v-virtual-table">{{ text }}</font>
          <font color="success" class="v-virtual-table">{{ successmessage }}</font>
          <v-btn
            depressed
            class="primary_btn small mt-8"
            :disabled="!valid"
            @click="submit"
            >Email me a recovery link</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { emailRules } from '@/support/utils/form-rules.js';
import { mapActions, mapGetters } from 'vuex';
export default {
  data: () => ({
    input: {
      email: null,
    },
    forgotResponse: {},
    response: '',
    text: '',
    emailRules,
    valid: true,
    successmessage:'',
  }),
  computed: {
    ...mapGetters({
      authenticatedResult: 'user/authenticationResult',
    }),
  },
  methods: {
    ...mapActions({
      userForgotPassword: 'users/forgotPassword',
    }),
    submit: async function () {
      if (this.$refs.form.validate()) {
        this.forgotResponse = await this.userForgotPassword({
          email: this.input.email,
        });
        localStorage.setItem('email', this.input.email);
        let statuscode = this.forgotResponse.status;
        if (statuscode === 200) {
          this.text='';
          this.successmessage = this.forgotResponse.data.message;
        } else {
          this.successmessage='';
          this.text = this.forgotResponse.data.message;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-virtual-table {
  position: absolute;
}
</style>